module.exports = __webpack_public_path__ + "img/cq3-banner-back.2e95ae64.png";